import React from 'react';

const CURRENCIES = ['MYR', 'USD', 'SGD', 'EUR'];
const PRICE_TYPES = ['one-time', 'monthly', 'annual', 'quote'];

const PricingSection = ({ formData, handleNestedChange }) => {
  const pricing = formData.pricing || {};
  const subscription = pricing.subscription || {};

  return (
    <div className="form-section">
      <h3>Pricing</h3>
      <div className="form-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={pricing.enabled || false}
            onChange={(e) => handleNestedChange('pricing.enabled', e.target.checked)}
          />
          Enable Pricing Display
        </label>
      </div>

      {pricing.enabled && (
        <>
          <div className="form-row">
            <div className="form-group">
              <label>Price</label>
              <input
                type="number"
                step="0.01"
                min="0"
                value={pricing.price ?? ''}
                onChange={(e) => handleNestedChange('pricing.price', parseFloat(e.target.value) || 0)}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>Currency</label>
              <select
                value={pricing.currency || 'MYR'}
                onChange={(e) => handleNestedChange('pricing.currency', e.target.value)}
                className="form-control"
              >
                {CURRENCIES.map(c => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Price Type</label>
              <select
                value={pricing.priceType || 'quote'}
                onChange={(e) => handleNestedChange('pricing.priceType', e.target.value)}
                className="form-control"
              >
                {PRICE_TYPES.map(pt => (
                  <option key={pt} value={pt}>{pt}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Subscription - Monthly</label>
              <input
                type="number"
                step="0.01"
                min="0"
                value={subscription.monthly ?? ''}
                onChange={(e) => handleNestedChange('pricing.subscription.monthly', parseFloat(e.target.value) || 0)}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>Subscription - Annual</label>
              <input
                type="number"
                step="0.01"
                min="0"
                value={subscription.annual ?? ''}
                onChange={(e) => handleNestedChange('pricing.subscription.annual', parseFloat(e.target.value) || 0)}
                className="form-control"
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PricingSection;
